import { LogIn } from 'lucide-react';
import { useAuth } from '../../core/auth/AuthProvider';
import { Button } from '../shadcn/button';
import { Card, CardContent } from '../shadcn/card';
import { useTranslation } from 'react-i18next';

export interface SignInPromptProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  className?: string;
}

export function SignInPrompt({ 
  title, 
  description, 
  icon, 
  className = "" 
}: SignInPromptProps) {
  const { signIn } = useAuth();
  const { t } = useTranslation();

  const handleSignIn = () => {
    signIn();
  };

  return (
    <Card className={`p-8 ${className}`}>
      <CardContent className="flex flex-col items-center justify-center space-y-6 text-center">
        <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
          {icon || <LogIn className="h-8 w-8 text-blue-500" />}
        </div>
        <div className="space-y-2">
          <h3 className="text-xl font-semibold text-gray-900">
            {title || t('auth.signInRequired.title', 'Sign in required')}
          </h3>
          <p className="text-gray-600 max-w-md">
            {description || t('auth.signInRequired.description', 'Please sign in to access this feature')}
          </p>
        </div>
        <Button onClick={handleSignIn} className="gap-2">
          <LogIn className="h-4 w-4" />
          {t('auth.signIn', 'Sign In')}
        </Button>
      </CardContent>
    </Card>
  );
} 